import { useUSPsDeliveryTerms } from "@/data/Content/USPsDeliveryTerms";
import { ID } from "@/data/types/Basic";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { CheckIcon } from './checkIcon';
import { FC } from "react";
import { useLocalization } from "@/data/Localization";
import { isEmpty } from "lodash";
import { LocalizationWithComponent } from "@/components/blocks/LocalizationWithComponent";
import { checkIconSX, uspContainerSX } from "./styles/uspsDeliveryTems";
import { USPDeliveryTerms } from "@/data/types/USPDeliveryTerms";
export const EMPTY_STRING = '';

export const USPsDeliveryTems: FC<{ id: ID }> = () => {
    const uspDelTermsNLS = useLocalization("USPDeliveryTerms");
    const {uspsDeliveryTerms} = useUSPsDeliveryTerms();
    const {
        checkPrice, 
        msgDeliveryTerm, 
        pickUpInStoreAllowed, 
        preSaleCatentry,
        hostURL,
        orderFreeShippingMinimumActualFinal,
        orderShippingMinimumActualFinal,
        orderFreeShippingMinimumFinal
    } = uspsDeliveryTerms?? {} as USPDeliveryTerms;
    

    return(
        <List sx={uspContainerSX}>
            {!isEmpty(msgDeliveryTerm) && !preSaleCatentry && 
                <ListItem disablePadding >
                    <ListItemIcon sx={checkIconSX}><CheckIcon {...{hostURL}} /></ListItemIcon>
                    <ListItemText primary={uspDelTermsNLS.USP_DHL_DELIVERY_TERM.t()} />
                </ListItem>
            }

            {preSaleCatentry && 
                <ListItem disablePadding >
                    <ListItemIcon sx={checkIconSX}><CheckIcon {...{hostURL}} /></ListItemIcon>
                    <ListItemText primary={msgDeliveryTerm} />
                </ListItem>
            }

            {pickUpInStoreAllowed && 
                <ListItem disablePadding >
                    <ListItemIcon sx={checkIconSX}><CheckIcon {...{hostURL}} /></ListItemIcon>
                    <ListItemText primary={uspDelTermsNLS.USP_PICKUP_IN_STORE_ENABLED_TEXT.t()} />
                </ListItem>
            }

            {checkPrice && checkPrice < orderShippingMinimumActualFinal && <ListItem disablePadding>
                <ListItemIcon sx={checkIconSX}><CheckIcon {...{hostURL}} /></ListItemIcon>
                    <ListItemText primary={
                                    <LocalizationWithComponent
                                        text={uspDelTermsNLS.USP_DELIVERY_COST_1.t({ orderFreeShippingMinimumFinal })}
                                    />
                                }
                    />
                </ListItem>
            }

            {checkPrice && checkPrice > orderShippingMinimumActualFinal && checkPrice < orderFreeShippingMinimumActualFinal && 
                <ListItem disablePadding>
                    <ListItemIcon sx={checkIconSX}><CheckIcon {...{hostURL}} /></ListItemIcon>
                    <ListItemText primary={
                                    <LocalizationWithComponent
                                        text={uspDelTermsNLS.USP_DELIVERY_COST_2.t({ orderFreeShippingMinimumFinal })}
                                    />
                                }
                    />
                </ListItem>
            }

            {checkPrice && checkPrice > orderShippingMinimumActualFinal && checkPrice > orderFreeShippingMinimumActualFinal && 
                <ListItem disablePadding>
                    <ListItemIcon sx={checkIconSX}><CheckIcon {...{hostURL}} /></ListItemIcon>
                    <ListItemText primary={uspDelTermsNLS.USP_DELIVERY_COST_3.t()}/>
                </ListItem>
            }

            <ListItem disablePadding>
                <ListItemIcon sx={checkIconSX}><CheckIcon {...{hostURL}} /></ListItemIcon>
                <ListItemText primary={uspDelTermsNLS.USP_STATIC_CONTENT.t()} />
            </ListItem>
        </List>
    );
}